import React from 'react'
import {
    Events,
    type CustomEvents,
    PopupMessageModal as PopupMessageModalComponent,
} from '../zaptic-popup-message-modal'
import { createComponent, type EventName } from '@lit-labs/react'

export const PopupMessageModal = createComponent(React, 'zaptic-popup-message-modal', PopupMessageModalComponent, {
    onCancel: Events.onCancel as EventName<CustomEvents[Events.onCancel]>,
    onSubmit: Events.onSubmit as EventName<CustomEvents[Events.onSubmit]>,
    onOptionalButtonClick: Events.onOptionalButtonClick as EventName<CustomEvents[Events.onOptionalButtonClick]>,
})
